import { List, NeoModel, ValueObject } from '@singularsystems/neo-core';
import { ExchangeRateLookupHistoryCriteriaDetail } from './ExchangeRateLookupHistoryCriteriaDetail';

@NeoModel
export default class ExchangeRateLookupHistoryCriteria extends ValueObject {

    public rates = new List(ExchangeRateLookupHistoryCriteriaDetail);

    // Client only properties / methods
}